import { Injectable, signal } from '@angular/core';

export enum ToastType {
  INFO = 'info',
  ERROR = 'error',
}

export interface ToastMessage {
  message: string;
  type: ToastType;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService<T> {
  messages = signal([]);

  add(message: T, type = ToastType.INFO, duration = 4000) {
    this.messages.update((currentValue) => [
      ...currentValue,
      { message, type },
    ]);
    setTimeout(() => {
      this.remove();
    }, duration);
  }

  clear() {
    this.messages.update(() => []);
  }

  private remove() {
    this.messages.update((currentValue) => [
      ...currentValue.slice(0, this.messages().length - 1),
    ]);
  }
}
